import { Box, Text } from '@primer/react';
import { DateBox } from 'devextreme-react';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { saleSetDichVuApi } from '../../../../api/saleSetRegisterDichVu';
import ComboMaHSFilter from "../../../../components/combo-maHS-filter";
import DataGrid from "../../../../components/data-grid";
import { IDataGridColumn } from "../../../../components/data-grid/type/IDataGridProps";
import Button from "../../../../components/ui/button";
import ModalActions from "../../../../components/ui/modal/ModalActions";
import MyModal from "../../../../components/ui/modal/MyModal";
import { showNotify } from '../../../../helpers/toast';
import { ts_hocsinh_viewmodel } from '../../../../models/response/hocsinh/ts_hocsinh';
import { sf_saleset_register_dichvu_viewmodel } from "../../../../models/response/sale-set-dichvu/sf_saleset_register_dichvu";
import { RootState } from '../../../../state/reducers';

type Props = {
    title?: string,
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: sf_saleset_register_dichvu_viewmodel) => void,
    sf_saleset_register_dichvu_editting?: sf_saleset_register_dichvu_viewmodel,
    is_saving?: boolean,
    animationOf?: string,
    ts_hocsinh?: ts_hocsinh_viewmodel,
}

type DichVuRow = sf_saleset_register_dichvu_viewmodel & {
    is_checked?: boolean;
};

const DangKyDichVuHocSinhModal = (props: Props) => {
    const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common);
    const sf_khoannop_groups = useSelector((x: RootState) => x.khoanNopGroup.sf_khoannop_groups);
    const { onClose: onCloseProp } = props;
    const [dichVuRows, setDichVuRows] = useState<DichVuRow[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState<sf_saleset_register_dichvu_viewmodel>({
        id: 0,
        nam_hoc: nam_hoc,
        dm_truong_id: props.ts_hocsinh?.dm_truong_id || 0,
        ts_hocsinh_id: props.ts_hocsinh?.id || 0,
        sf_khoannop_group_id: 0,
        sf_saleset_register_dichvu_status_id: 1,
        tu_ngay: moment().format("YYYY-MM-DDTHH:mm:ss"),
        den_ngay: '',
        is_active: true,
        ma_hs: props.ts_hocsinh?.ma_hs || '',
        ho_ten: props.ts_hocsinh?.ho_ten || '',
        ma_khoan_nop_group: '',
        ten_khoan_nop_group: '',
        ten_lop: props.ts_hocsinh?.ten_lop || '',
        trang_thai: '',
        trang_thai_dich_vu: '',
        dm_khoi_id: props.ts_hocsinh?.dm_khoi_id || 0,
        dm_he_id: props.ts_hocsinh?.dm_he_id || 0,
        dm_lop_id: 0,
        ngay_sinh: '',
        sf_saleset_register_type_id: 0
    });

    const loadDichVuByHocSinh = useCallback(async (ts_hocsinh_id: number) => {
        if (!ts_hocsinh_id || !nam_hoc) {
            setDichVuRows([]);
            return;
        }
        setIsLoading(true);
        try {
            const allDichVus = (sf_khoannop_groups || []).filter(
                (x: any) => x.dm_coso_id === dm_coso_id && (x.is_dichvu || x.is_dichvu_fixed)
            );

            const res = await saleSetDichVuApi.select_by_hocsinh({
                ts_hocsinh_id,
                nam_hoc,
            });

            const registeredMap = new Map<number, any>();
            if (res.is_success && Array.isArray(res.data)) {
                res.data.forEach((x: any) => {
                    const key = Number(x.sf_khoannop_group_id || 0);
                    if (!key) return;
                    if (!registeredMap.has(key)) {
                        registeredMap.set(key, x);
                    } else {
                        const current = registeredMap.get(key);
                        const curDate = current.tu_ngay ? moment(current.tu_ngay) : null;
                        const newDate = x.tu_ngay ? moment(x.tu_ngay) : null;
                        if (newDate && (!curDate || newDate.isAfter(curDate))) {
                            registeredMap.set(key, x);
                        }
                    }
                });
            }

            const rows: DichVuRow[] = allDichVus.map((dv: any) => {
                const registered = registeredMap.get(dv.id);
                if (registered) {
                    return {
                        ...registered,
                        ten_khoan_nop_group: dv.ten_khoan_nop_group || registered.ten_khoan_nop_group,
                        ma_khoan_nop_group: dv.ma_khoan_nop_group || registered.ma_khoan_nop_group,
                        is_checked: Number(registered.sf_saleset_register_dichvu_status_id || 0) === 1 || Number(registered.sf_saleset_register_dichvu_status_id || 0) === 2,
                    };
                } else {
                    return {
                        id: 0,
                        nam_hoc: nam_hoc,
                        ts_hocsinh_id: ts_hocsinh_id,
                        sf_khoannop_group_id: dv.id,
                        sf_saleset_register_dichvu_status_id: 3,
                        tu_ngay: '',
                        den_ngay: '',
                        is_active: true,
                        ma_hs: formData.ma_hs || '',
                        ho_ten: formData.ho_ten || '',
                        ma_khoan_nop_group: dv.ma_khoan_nop_group || '',
                        ten_khoan_nop_group: dv.ten_khoan_nop_group || '',
                        ten_lop: formData.ten_lop || '',
                        trang_thai: '',
                        trang_thai_dich_vu: '',
                        dm_khoi_id: 0,
                        dm_he_id: 0,
                        dm_lop_id: 0,
                        ngay_sinh: '',
                        sf_saleset_register_type_id: 0,
                        is_checked: false,
                    };
                }
            });

            setDichVuRows(rows);
        } catch (e) {
            setDichVuRows([]);
        } finally {
            setIsLoading(false);
        }
    }, [nam_hoc, dm_coso_id, sf_khoannop_groups, formData.ma_hs, formData.ho_ten, formData.ten_lop]);

    useEffect(() => {
        if (formData.ts_hocsinh_id) {
            loadDichVuByHocSinh(formData.ts_hocsinh_id);
        }
    }, [formData.ts_hocsinh_id, loadDichVuByHocSinh]);

    useEffect(() => {
        if (props.ts_hocsinh) {
            setFormData((prev) => ({
                ...prev,
                ts_hocsinh_id: props.ts_hocsinh!.id,
                ho_ten: props.ts_hocsinh!.ho_ten,
                ma_hs: props.ts_hocsinh!.ma_hs,
                ten_lop: props.ts_hocsinh!.ten_lop,
                dm_khoi_id: props.ts_hocsinh!.dm_khoi_id,
                dm_he_id: props.ts_hocsinh!.dm_he_id,
                dm_truong_id: props.ts_hocsinh!.dm_truong_id
            }));
        }
    }, [props.ts_hocsinh]);

    const columns = useMemo<IDataGridColumn[]>(() => {
        return [
            {
                id: "dv",
                caption: "Dịch vụ",
                dataField: "ten_khoan_nop_group",
                width: 260,
                fixed: "left",
                isMainColumn: true,
            },
            {
                id: "tu_ngay",
                caption: "Từ ngày",
                dataField: "tu_ngay",
                width: 150,
                align: "center",
                cellRender: (row: any) => {
                    return (
                        <DateBox
                            stylingMode="outlined"
                            value={row.tu_ngay}
                            displayFormat={'dd-MM-yyyy'}
                            dateSerializationFormat={'yyyy-MM-ddTHH:mm:ss'}
                            useMaskBehavior={true}
                            onValueChanged={(e: any) => {
                                setDichVuRows((prev) =>
                                    prev.map((x) =>
                                        x.sf_khoannop_group_id === row.sf_khoannop_group_id
                                            ? { ...x, tu_ngay: e.value }
                                            : x
                                    )
                                );
                            }}
                        />
                    );
                },
            },
            {
                id: "den_ngay",
                caption: "Đến ngày",
                dataField: "den_ngay",
                width: 150,
                align: "center",
                cellRender: (row: any) => {
                    return (
                        <DateBox
                            stylingMode="outlined"
                            value={row.den_ngay}
                            displayFormat={'dd-MM-yyyy'}
                            dateSerializationFormat={'yyyy-MM-ddTHH:mm:ss'}
                            useMaskBehavior={true}
                            onValueChanged={(e: any) => {
                                setDichVuRows((prev) =>
                                    prev.map((x) =>
                                        x.sf_khoannop_group_id === row.sf_khoannop_group_id
                                            ? { ...x, den_ngay: e.value }
                                            : x
                                    )
                                );
                            }}
                        />
                    );
                },
            },
        ];
    }, []);

    const handleSaveAll = useCallback(async () => {
        if (!formData.ts_hocsinh_id) {
            showNotify({ message: "Vui lòng chọn học sinh", type: "warning" });
            return;
        }

        const invalid = dichVuRows.find((x) => x.is_checked && (!x.tu_ngay || String(x.tu_ngay).trim() === ""));
        if (invalid) {
            showNotify({ message: "Vui lòng chọn Từ ngày cho các dịch vụ đã đăng ký", type: "warning" });
            return;
        }

        setIsLoading(true);
        try {
            const items = dichVuRows
                .filter((r) => {
                    const isChecked = !!r.is_checked;
                    if ((!r.id || r.id === 0) && !isChecked) return false;
                    if (!r.sf_khoannop_group_id || r.sf_khoannop_group_id === 0) return false;
                    return true;
                })
                .map((r) => {
                    const isChecked = !!r.is_checked;
                    const statusId = r.sf_saleset_register_dichvu_status_id || (isChecked ? 1 : 3);
                    return {
                        ts_hocsinh_id: formData.ts_hocsinh_id,
                        sf_khoannop_group_id: r.sf_khoannop_group_id || 0,
                        nam_hoc: nam_hoc,
                        sf_saleset_register_dichvu_status_id: statusId,
                        tu_ngay: isChecked ? (r.tu_ngay || moment().format("YYYY-MM-DDTHH:mm:ss")) : (r.tu_ngay || ""),
                        den_ngay: isChecked ? (r.den_ngay || "") : (r.den_ngay || ""),
                        is_active: true,
                        sf_saleset_register_type_id: r.sf_saleset_register_type_id || 0,
                    };
                });

            if (items.length === 0) {
                showNotify({ message: "Không có dữ liệu để cập nhật", type: "warning" });
                setIsLoading(false);
                return;
            }

            const res = await saleSetDichVuApi.insert_multiple({
                items: items
            });

            if (res.is_success) {
                showNotify({ message: res.message || "Cập nhật thành công", type: "success" });
                await loadDichVuByHocSinh(formData.ts_hocsinh_id);
                onCloseProp();
                props.onSubmit(formData);
            } else {
                showNotify({ message: res.message || "Có lỗi xảy ra", type: "error" });
            }
        } catch (e: any) {
            showNotify({ message: e?.message || "Có lỗi", type: "warning" });
        } finally {
            setIsLoading(false);
        }
    }, [dichVuRows, formData, nam_hoc, loadDichVuByHocSinh, onCloseProp, props]);

    const onClose = useCallback(() => {
        onCloseProp();
    }, [onCloseProp]);

    return (
        <MyModal
            isOpen={props.isOpen}
            onClose={onClose}
            title={props.title || "Đăng ký dịch vụ"}
            width="70%"
        >
            <Box sx={{ p: 3 }}>
                {!props.ts_hocsinh && (
                    <Box sx={{ mb: 3 }}>
                        <Text as="p" sx={{ mb: 1, fontWeight: 600 }}>
                            Mã học sinh
                        </Text>
                        <ComboMaHSFilter
                            defaultValue={{ ma_hs: formData.ma_hs, ts_hocsinh_hoten: formData.ho_ten }}
                            onResultChanged={(value) => {
                                setFormData({
                                    ...formData,
                                    ma_hs: value.ts_hocsinh.ma_hs,
                                    ho_ten: value.ts_hocsinh.ho_ten,
                                    ts_hocsinh_id: value.ts_hocsinh.id
                                });
                                loadDichVuByHocSinh(value.ts_hocsinh.id);
                            }}
                        />
                    </Box>
                )}

                <Box sx={{ mb: 2 }}>
                    <Text as="p" sx={{ mb: 1, fontWeight: 600 }}>
                        Danh sách dịch vụ
                    </Text>
                    {isLoading ? (
                        <Box sx={{ textAlign: "center", padding: 3 }}>Đang tải dữ liệu...</Box>
                    ) : (
                        <DataGrid
                            dataSource={dichVuRows}
                            columns={columns}
                            keyExpr="sf_khoannop_group_id"
                            height={window.innerHeight - 420}
                            isLoading={isLoading}
                            searchEnable={true}
                            exportConfig={{ enable: false }}
                            selection={{
                                mode: "multiple",
                                selectedRowKeys: dichVuRows
                                    .filter((x) => x.is_checked)
                                    .map((x) => x.sf_khoannop_group_id),
                                onSelectionChanged: (keys: any[]) => {
                                    setDichVuRows((prev) =>
                                        prev.map((x) => ({
                                            ...x,
                                            is_checked: keys.includes(x.sf_khoannop_group_id),
                                            tu_ngay: keys.includes(x.sf_khoannop_group_id)
                                                ? (x.tu_ngay || moment().format("YYYY-MM-DDTHH:mm:ss"))
                                                : x.tu_ngay,
                                        }))
                                    );
                                },
                            }}
                        />
                    )}
                </Box>
            </Box>

            <ModalActions>
                <Button variant="default" onClick={onClose}>
                    Đóng
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSaveAll}
                    isLoading={isLoading}
                >
                    Cập nhật
                </Button>
            </ModalActions>
        </MyModal>
    );
};
export default DangKyDichVuHocSinhModal